import React, { useEffect, useState } from "react";
import { InfoCircleFill } from "react-bootstrap-icons";
import useBorrowerDashboardTwo from "./apis/useBorrowerDashboardTwo";
import { useDispatch, useSelector } from "react-redux";
import { fetchBorrowerMaturingLoans } from "../../../store/reducers/dashboardSlice/api";
import { loadingTypes } from "../../../Utils/constant";
import { SpinnerBlock } from "../../../Utils/CustomComponent";
import PopupWrapper from "../../../components/PopupWrapper";
import ErrorBoundary from "../../../components/ErrorBoundary";
import CommonGrid from "../../../components/CommonGrid";
import { gridColumns_LoansMaturing } from "../../../Utils/TableColumnDefs";

const headers = {
  headers: {
    "Content-Type": "application/json",
    Authorization: "Basic UkVTVEFQSUxPQU5MSU5ROjg4V2VIZWxwVSQjQA==",
  },
};

const LoanMaturity = () => {
  const [show, setShow] = useState(false);

  const data = useSelector(
    (state) => state.dashboard.borrowerMaturingLoans.data
  );
  const status = useSelector(
    (state) => state.dashboard.borrowerMaturingLoans.status
  );
  const { activeAccountList } = useBorrowerDashboardTwo();
  const dispatch = useDispatch();

  const requestedBody = {
    RecID: activeAccountList?.map((el) => el.value).join(" "),
  };

  useEffect(() => {
    if (status === loadingTypes.idle && activeAccountList?.length) {
      dispatch(
        fetchBorrowerMaturingLoans({
          requestedBody,
          headers,
        })
      );
    }
  }, [status, dispatch, activeAccountList]);

  return (
    <div
      className="card h-100 shadow-sm p-3 border border-primary loansMaturing clickable-card"
      role="button"
    >
      {status === loadingTypes.fulfilled ? (
        <div
          className="card-body d-flex flex-column"
          onClick={() => setShow(true)}
        >
          <div className="d-flex justify-content-between align-items-center mb-2">
            <h5 className="card-title mb-0">Loans Maturing</h5>
            <span
              className="text-muted"
              data-bs-toggle="tooltip"
              title="Loans that are scheduled to reach maturity within the next 30 days."
            >
              <InfoCircleFill />
            </span>
          </div>
          <p className="text-muted small mb-1">Within 30 Days</p>
          <div className="mt-auto">
            <h2 className="mb-0">{data?.length}</h2>
          </div>
        </div>
      ) : status === loadingTypes.loading ? (
        <div>
          {" "}
          <SpinnerBlock height="5vh" />
        </div>
      ) : null}
      <LoansMaturingModal
        show={show}
        setShow={setShow}
        data={data}
        status={status}
      />
    </div>
  );
};

export default LoanMaturity;

const LoansMaturingModal = ({ show, setShow, data, status }) => {
  return (
    <PopupWrapper
      Component={
        <ErrorBoundary>
          <CommonGrid
            status={status}
            className={``}
            title={"Loans Maturing"}
            gridColumns={gridColumns_LoansMaturing}
            columnData={data}
            viewAllModal={false}
          />
        </ErrorBoundary>
      }
      title={"Loans Maturing"}
      toShow={show}
      closeEventHandler={() => {
        setShow(false);
      }}
    />
  );
};
